import TitleEditField from "../atom/TitleEditField";
import DescEditField from "../atom/DescEditField";
import React from "react";


const AddHistoryForm = ({handleInputChange, formData}) => {

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0];
  return (
    <div className={"detail-design-history-contents"}>
      <div className={"detail-design-history-date"}>
        <span>{formattedDate}</span>
      </div>
      <TitleEditField handleInputChange={handleInputChange} formData={formData}/>
      <DescEditField handleInputChange={handleInputChange} formData={formData}/>
    </div>
  )


}
export default AddHistoryForm
